// ported from https://github.com/ShogunPanda/http-errors-enhanced

import { EHttpCode, identifierByCodes, messagesByCodes, phrasesByCodes } from './statuses';

interface Properties extends Error {
  status: EHttpCode;
  statusCode: EHttpCode; // This always mirrors status
  statusClass: number;
  code: string;
  error: string;
  errorPhrase: string;
  headers: { [key: string]: string };
  isClientError: boolean;
  isServerError: boolean;
  data: unknown;
  response?: Response;

  [key: string]: unknown;
}

export type { EHttpCode };

export default class HttpError extends Error implements Properties {
  static standardErrorPrefix = 'HTTP_ERROR_';

  status: EHttpCode;

  statusCode: EHttpCode; // This always mirrors status

  statusClass: number;

  code: string;

  error: string;

  errorPhrase: string;

  headers: { [key: string]: string };

  isClientError: boolean;

  isServerError: boolean;

  data: unknown;

  response: Response | undefined;

  [key: string]: unknown;

  constructor(response: Response, props: Partial<Properties> = {}) {
    const { status } = response;

    super(response.statusText);

    this.response = response;

    if (status < 400 || status > 599) {
      this.status = 500;
    } else {
      this.status = status as EHttpCode;
    }

    this.statusCode = this.status;
    this.error = messagesByCodes[this.status];
    this.errorPhrase = phrasesByCodes[this.status];

    this.headers = Object.fromEntries(Object.entries(response.headers));
    this.stack = props.stack || this.stack;
    this.data = props.data;

    // Assign serialization properties
    const code = identifierByCodes[this.status];
    this.name = 'HttpError';
    this.code = props.code || `${HttpError.standardErrorPrefix}${code.replace(/([a-z])([A-Z])/g, '$1_$2').toUpperCase()}`;

    // Assign helpers properties
    this.isClientError = this.status < 500;
    this.isServerError = !this.isClientError;
    this.statusClass = this.isClientError ? 400 : 500;

    // Configure properties
    Object.defineProperties(this, {
      status: { enumerable: false },
      code: {
        enumerable: !this.code.startsWith(HttpError.standardErrorPrefix),
      },
      errorPhrase: { enumerable: false },
      headers: { enumerable: false },
      name: { enumerable: false },
      isClientError: { enumerable: false },
      isServerError: { enumerable: false },
      statusClass: { enumerable: false },
      expose: { enumerable: false },
    });
  }
}
